import { useCallback } from 'react';

export default function useMapControl(mapRef) {
    const handleZoomIn = useCallback(() => {
        const map = mapRef.current;
        if (map) {
          const currentZoom = map.getZoom();
          map.setZoom(currentZoom + 1, { duration: 200 });
        }
      }, []);
    
      const handleZoomOut = useCallback(() => {
        const map = mapRef.current;
        if (map) {
          const currentZoom = map.getZoom();
          map.setZoom(currentZoom - 1, { duration: 200 });
        }
      }, []);
    
      const handleLocateMe = useCallback(() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
              const map = mapRef.current;
              if (map) {
                const { latitude, longitude } = coords;
                map.setCenter([latitude, longitude], map.getZoom(), { duration: 200 });
              }
            },
            (err) => {
              console.error('Geolocation error:', err);
            },
            { enableHighAccuracy: true }
          );
        }
      }, []);

      return {
        handleZoomIn,
        handleZoomOut,
        handleLocateMe
      };
}